<template>
    <div v-if="this.$root.selectedCountry" class="country-header">
        <div class="hero">
            <div class="background background--cover background--bottom hero__background">
                <div class="background__image lazyloaded">&nbsp;</div>
            </div>
            <nav class="breadcrumbs breadcrumbs--transparent">
                <div class="spring">
                    <ol class="breadcrumbs__list">
                        <li class="breadcrumbs__item">
                            <router-link :to="{ name: 'main' }">Home</router-link>
                            <svg focusable="false" aria-hidden="true" class="icon icon--small breadcrumbs__chevron">
                                <use xlink:href="#icon-chevron-right"></use>
                            </svg>
                        </li>
                        <li class="breadcrumbs__item">
                            <span class="breadcrumbs__crumb breadcrumbs__crumb--current">
                                {{ this.$root.selectedCountry.name }}
                                <svg focusable="false" aria-hidden="true" class="icon icon--small breadcrumbs__chevron">
                                    <use xlink:href="#icon-chevron-right"></use>
                                </svg>
                                <span v-if="this.$root.serviceActive">{{ $root.serviceActive.name_short }}</span>
                            </span>
                        </li>
                    </ol>
                </div>
            </nav>
            <div class="hero__band">
                <div class="hero__message">
                    <div class="spring text-left">
                        <h1 class="heading heading--1 heading--light heading--leading hero__heading">
                            <span class="grid--gutter grid">
                                <span class="grid__item grid__item--gutter grid__item--sm-1/1 text-center">
                                    <span class="thumbnail">
                                        <img :src="'https://static.vodafone.ro/roaming/images/countries/cntr-flag-' + this.$root.selectedCountry.flagURL + '.png'" alt />
                                    </span>
                                </span>
                                <span class="grid__item grid__item--gutter grid__item--sm-align-center grid__item--align-left grid__item--sm-1/1">
                                    <span>{{ this.$root.selectedCountry.name }}</span>
                                    <a @click.prevent="$root.$refs['countrySelectorFull'].show()" href class="schimba-destinatia heading heading--6 heading--regular heading--leading heading--trailing">Schimbă destinația</a>
                                </span>
                            </span>
                        </h1>
                        <h1 v-if="this.$root.serviceActive" class="heading heading--1 heading--light heading--leading hero__heading">
                            <span class="heading heading--4 heading--leading heading--trailing">{{ this.$root.selectedCountry.messageLocal }}</span>
                            <span class="heading heading--6 heading--regular heading--leading heading--trailing">{{ this.$root.selectedCountry.messageRo }}</span>
                            <span class="heading heading--6 heading--regular heading--leading heading--trailing">
                                Prefix:
                                <strong>+{{ this.$root.selectedCountry.countryPhonePrefix }}</strong>
                            </span>
                            <span class="heading heading--6 heading--regular heading--leading heading--trailing">
                                <div v-if="this.$root.serviceActive.name_short === 'Abonament'">
                                    <div v-if="this.$root.selectedCountry.countryGroup">
                                        Grupa: <span>{{ this.$root.selectedCountry.countryGroup }}</span>
                                    </div>
                                    <div v-if="this.$root.selectedCountry.postpaid === 1 && !this.$root.selectedCountry.countryGroup">Spatiul Economic European</div>
                                </div>
                                <div v-if="this.$root.serviceActive.name_short === 'Cartelă'">
                                    <div v-if="this.$root.selectedCountry.prepaid">
                                        Zona: <span>{{ this.$root.selectedCountry.prepaid }}</span>
                                    </div>
                                </div>
                                <div v-if="this.$root.serviceActive.name_short === 'Internet'">
                                    <div v-if="this.$root.selectedCountry.internet">
                                        Zona: <span>{{ this.$root.selectedCountry.internet }}</span>
                                    </div>
                                </div>
                            </span>
                        </h1>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'CountryHeader',
};
</script>
